export default __webpack_public_path__ + "static/media/meeting.5011346f.svg";